<template>
    <v-layout v-if="items" class="breadcrumb" row wrap fill-height align-center justify-start>
        <!--asfd{{JSON.stringify(items)}}asdf-->
        <div style="display:inline-flex;" v-for="(item, index) in items" :key="item.label">
            <v-flex>
                <v-chip outlined color="#da8d2b" text-color="black" :disabled="item['disabled']"
                    style="min-height: 35px;" :to="getItemLink(item['view'], item['parameter'])">
                    <!-- @click.stop="launchAction(item['view'],item['parameter'])" -->
                    <v-avatar left>
                        <v-icon>{{ item["icon"] }}</v-icon>
                    </v-avatar>
                    <span style="color:black;line-height: 15px">{{ item["label"] }}</span>
                    <!--<span v-if="item['parameter']">({{item["parameter"]}})</span>-->
                </v-chip>
            </v-flex>
            <v-flex>
                <v-icon v-if="index + 1 < items.length">
                    arrow_forward
                </v-icon>
            </v-flex>
            <v-spacer v-if="index + 1 == items.length" :key="index">
            </v-spacer>
        </div>
    </v-layout>
</template>
<script>
export default {
    name: 'breadcrumb-element',
    props: {
        items: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            page: null,
            section: null,
            subsection: null,
        };
    },
    created: function () {
        const params = this.$route.params;

        this.page = params.page;
        this.section = params.section;
        this.subsection = params.subsection;
    },
    mounted: function () {
    },
    methods: {
        getItemLink(view, cod) {
            var link;

            link = '/pages/' + this.page + "/" + this.section + "/" + this.subsection;

            if (view) {
                link += "/" + view;
            }

            if (cod) {
                link += "/" + cod;
            }

            return link;
        },
        launchAction(view, inputParams, modifiers) {
            this.$emit('clicked', view + (inputParams ? "/" + inputParams : "") + "/" + (modifiers ? "/" + inputParams : ""));
        }
    }
};
</script>
<style>
.breadcrumb .flex {
    /*background-color: red;*/
    padding: 0 !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    flex: 0;
}

.breadcrumb .flex .v-chip {
    /*background-color: transparent !important;*/
    /*border:1px solid black;*/
    margin: 0 !important;
}

.breadcrumb .flex .v-chip:before {
    /*background-color: cornsilk !important;*/
}

.breadcrumb .flex .v-chip .v-icon {
    padding: 0 !important;
}

.breadcrumb .flex .v-chip .v-chip__content {
    font-size: 18px;
}
</style>
